import { mesaColorNames } from '@/src/common/theme'
import { StyleSheet, TouchableOpacity } from 'react-native'
import { triggerSegmentAction } from '@/src/services/segment'
import type { PropsWithChildren } from 'react'
import { Link } from 'expo-router'
import { SimpleLineIcons } from '@expo/vector-icons'
import Animated from 'react-native-reanimated'
import { useFeatureGate } from '@/src/services/Statsig/useFeatureGate'
import { NotificationsStatsig } from '@/src/experiences/notifications/statsig'
import type { ProfileProps } from '@/src/common/components/Profile/ProfileProps'
import { NotificationsEntryPoint } from '@/src/common/components/Profile/NotificationsEntryPoint'

export const profileMinHeight = 82

function MainMenuLink(props: PropsWithChildren) {
  return (
    <Link href="/main/menu" push asChild>
      {props.children}
    </Link>
  )
}

export function Profile({
  disabled,
  segmentAction = 'User pressed Profile Button',
  style,
  testID,
  contentWrapperStyle,
  menuWrapperProps,
  noticationWrapperProps,
  children,
  menuIconProps,
}: ProfileProps) {
  const isPushNotificationCenterActive = useFeatureGate(
    NotificationsStatsig.FeatureGate.PushNotificationCenter,
  ).featureGate?.value

  function onPress() {
    void triggerSegmentAction({ component: 'Profile Button', action: segmentAction })
  }

  return (
    <Animated.View style={style} testID={testID}>
      <MainMenuLink>
        <TouchableOpacity
          disabled={disabled}
          onPress={onPress}
          activeOpacity={0.8}
          style={StyleSheet.flatten([
            {
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              minHeight: profileMinHeight,
            },
            contentWrapperStyle,
          ])}
        >
          <MainMenuLink>
            <TouchableOpacity {...menuWrapperProps} onPress={onPress} testID="profile-menu">
              <SimpleLineIcons
                name="menu"
                size={24}
                color={mesaColorNames['Acre Turquoise/800 #086762']}
                {...menuIconProps}
              />
            </TouchableOpacity>
          </MainMenuLink>
          {children}
          {isPushNotificationCenterActive && (
            <NotificationsEntryPoint
              menuWrapperProps={menuWrapperProps}
              noticationWrapperProps={noticationWrapperProps}
              menuIconProps={menuIconProps}
            />
          )}
        </TouchableOpacity>
      </MainMenuLink>
    </Animated.View>
  )
}
